import { Images } from "../../../Images";
import Totals from "../../../model/crew/Totals";
import BigNum from "../../../model/math/BigNum";
import NumberFormatter from "../../../util/NumberFormatter";
import CurrencyContainerSectionView from "./CurrencyContainerSectionView";

export default class RubySectionView extends CurrencyContainerSectionView {
  /**
   * @param {string} parentId 
   * @param {Totals} totals 
   */
  constructor(parentId, totals) {
    super(parentId, parentId + 'ruby_section', 'Ruby', Images.currency.ruby, totals);

    /**
     * @constant
     * @type {BigNum}
     */
    this.displayedValue = new BigNum(0);
    /**
     * @type {string}
     */
    this.formattedValue = null;
  }

  /**
   * @override
   */
  updateViewContents() {

    const currency = this.totals.ruby;

    if (!this.formattedValue || !currency.equals(this.displayedValue)) {
      this.displayedValue.copy(currency);
      this.formattedValue = NumberFormatter.formatBigNum(currency);

      this.valueElement.innerHTML = this.formattedValue;
    }
  }

}